<template>
  <v-container>
    <create-client-modal
      :closedCallback="
        (client) => {
          reloadAndSelect(client);
        }
      "
    ></create-client-modal>
    <v-row>
      <v-col stretch>
        <v-breadcrumb :items="breadcrumbCreateProjectItems" :mobile="breadcrumbMobileItem"></v-breadcrumb>
      </v-col>
    </v-row>
    <v-row>
      <v-col stretch>
        <v-title-bar :title="$t('titles.createProject')">
          <v-button class="wrap-btn" primary @click.native="submitProject()" :active="submitActive">{{
            $t("actions.next")
          }}</v-button>
        </v-title-bar>
      </v-col>
    </v-row>
    <v-row>
      <v-col stretch>
        <form @submit.prevent>
          <v-textfield
            :label="$t('labels.giveName')"
            v-model="title"
            v-validate="'required'"
            name="title"
            @input.native="isValid()"
          ></v-textfield>
          <label for="client">{{ $t("labels.selectClient") }}</label>
          <v2-select
            :placeholder="$t('placeholders.searchForClient')"
            v-model="client"
            :options="clientOptions"
            id="client"
            name="client"
            optionLabel="last_name"
            v-validate="'required'"
            :searchable="true"
            :loading="isLoading"
            :internalSearch="false"
            @searchChange="loadClients"
            :customLabel="setCustomLabel"
            openDir="bottom"
            @input="isValid()"
          >
            <span slot="beforeList" class="multiselect__custom_link" @click="$modal.show('create-client')">{{
              $t("actions.createNewClient")
            }}</span>
          </v2-select>
          <label for="tags">{{ $t("labels.tags") }}</label>
          <v2-select
            :placeholder="$t('placeholders.addOrSearchTags')"
            :multiple="true"
            :tagPlaceholder="$t('placeholders.newTag')"
            id="tags"
            name="tags"
            v-model="tags"
            :options="tagsOptions"
            :taggable="true"
            @tag="addTag"
            :loading="isLoading"
            :internalSearch="true"
            :hideSelected="true"
            :closeOnSelect="false"
            :clearOnSelect="false"
            :showNoResults="false"
          ></v2-select>
        </form>
      </v-col>
      <v-col class="col-12 pb-0">
        <label>{{ $t("labels.selectTemplate") }}</label>
      </v-col>
      <v-col v-for="template in templates" :key="template.uid">
        <v-card
          template
          :color="template.thumbnail['bg-color']"
          :title="template.name"
          @click.native="selectTemplate(template)"
          :class="{
            'opacity-50': selectedTemplate && selectedTemplate.uid !== template.uid,
          }"
        >
          <div slot="icon" v-if="selectedTemplate && selectedTemplate.uid === template.uid">
            <v2-icon :data="require('@icon/Icon=check.svg')" width="25" height="25" color="green"></v2-icon>
          </div>
          <div slot="content">
            <img v-if="template.thumbnail.sm" :src="template.thumbnail.sm" alt="" />
            <img v-if="!template.thumbnail.sm" :src="templateThumbnailSmall" alt="" />
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col stretch>
        <div class="w-full flex justify-end">
          <v-button class="wrap-btn" primary @click.native="submitProject()" :active="submitActive">{{
            $t("actions.next")
          }}</v-button>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CreateClientModal from "./modals/CreateClientModal";

export default {
  name: "FormProject",
  components: { CreateClientModal },
  data() {
    return {
      templateThumbnailSmall: require("@/assets/svg/template-thumbnail-small.svg"),
      title: "",
      client: "",
      clientOptions: [],
      tags: [],
      tagsOptions: [],
      isLoading: false,
      selectedTemplate: null,
      submitActive: false,
      breadcrumbCreateProjectItems: [
        {
          label: this.$t("menus.projects"),
          route: { name: "Projects" },
        },
        {
          label: this.$t("menus.createProject"),
          active: true,
        },
      ],
      breadcrumbMobileItem: {
        label: this.$t("menus.projects"),
        route: { name: "Projects" },
      },
    };
  },
  created() {
    this.getTeamTemplates({ params: { per_page: "100" } }).then(() => {
      if (this.teamsSettings[this.$route.params.team].lastSelectedDesignTemplate) {
        this.selectedTemplate = this.teamsSettings[this.$route.params.team].lastSelectedDesignTemplate;
      } else if (this.templates.length === 1) {
        this.selectedTemplate = this.templates[0];
      }
    });
    this.initTagOptions();
    this.preselectClient();
    this.setOptions();
  },
  methods: {
    ...mapActions([
      "getClientList",
      "getTeamTemplates",
      "createProject",
      "getTeamTags",
      "getProjectTags",
      "setLastSelectedDesignTemplate",
    ]),
    setCustomLabel(client) {
      const name = this.$h.formatName(client);
      const email = "<" + client.email + ">";
      const res = name + " " + email;
      return `${res}`;
    },
    submitProject() {
      const vm = this;
      const data = {
        title: vm.title,
        owner_uid: vm.client.uid,
        template_uid: vm.selectedTemplate.uid,
      };
      vm.$validator.validateAll().then((result) => {
        if (result && vm.selectedTemplate) {
          vm.templates.forEach((template) => {
            if (template.uid === vm.selectedTemplate.uid) vm.setLastSelectedDesignTemplate(template);
          });
          vm.createProject({
            redirect: true,
            data,
            tags: { tags: vm.tags },
          }).then((res) => {
            vm.$goTo("Project", { uid: res.uid, tab: "overview" });
          });
        }
      });
    },
    selectTemplate(template) {
      !this.selectedTemplate || (this.selectedTemplate && this.selectedTemplate.uid !== template.uid)
        ? (this.selectedTemplate = template)
        : (this.selectedTemplate = null);
      this.isValid();
    },
    isValid() {
      this.$validator.validateAll().then((res) => {
        res && this.selectedTemplate ? (this.submitActive = true) : (this.submitActive = false);
      });
    },
    reloadAndSelect(client) {
      this.client = client;
      this.setOptions();
    },
    preselectClient() {
      if (this.newProjectClient) {
        this.client = this.newProjectClient;
        this.$store.commit("PROJECTS_SET_NEW_PROJECT_CLIENT", null);
      }
    },
    setOptions() {
      const params = {
        per_page: "1000",
        order_col: "last_name",
        order_dir: "ASC",
        search: "",
      };
      this.getClientList({ params, customLoading: true }).then((res) => {
        this.clientOptions = res;
      });
    },
    formatTagsOptions(tagsObjects) {
      this.tagsOptions = [];
      Object.keys(tagsObjects).forEach((key) => {
        this.tagsOptions.push(tagsObjects[key].name);
      });
    },
    addTag(newTag) {
      this.tagsOptions.push(newTag);
      this.tags.push(newTag);
    },
    initTagOptions() {
      this.isLoading = true;
      const params = {
        per_page: "1000",
      };
      this.getTeamTags({ params, customLoading: true }).then((res) => {
        this.formatTagsOptions(JSON.parse(JSON.stringify(res)));
        this.isLoading = false;
      });
    },
    loadClients(query) {
      if (query.length > 1) {
        this.isLoading = true;
        const params = {
          per_page: "1000",
          search: query,
        };
        this.getClientList({ params, customLoading: true }).then((res) => {
          this.clientOptions = res;
          this.isLoading = false;
        });
      } else if (query.length === 0) {
        this.isLoading = true;
        const params = {
          per_page: "1000",
          order_col: "last_name",
          order_dir: "ASC",
          search: "",
        };
        this.getClientList({ params, customLoading: true }).then((res) => {
          this.clientOptions = res;
          this.isLoading = false;
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      teams: "auth_get_teams",
      clients: "clients_get_client_list",
      templates: "templates_get_templates",
      newProjectClient: "projects_get_new_project_client",
      currentProjectTags: "projects_get_current_project_tags",
      teamsSettings: "global_get_teams_settings",
    }),
  },
};
</script>
